var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgScrollBtn(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 35,
    viewBox: "0 0 29 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.6755 0.119878L16.3243 0.119878L16.3243 3.7687L12.6755 3.7687L12.6755 0.119878Z",
    fill: "",
    stroke: "black",
    strokeWidth: 0.24
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.89768 23.4533L8.5465 23.4533L8.5465 27.1022L4.89768 27.1022L4.89768 23.4533Z",
    fill: "",
    stroke: "black",
    strokeWidth: 0.24
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.00877 19.5644L4.65759 19.5644L4.65759 23.2133L1.00877 23.2133L1.00877 19.5644Z",
    fill: "",
    stroke: "black",
    strokeWidth: 0.24
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24.1021 23.4533L20.4533 23.4533L20.4533 27.1022L24.1021 27.1022L24.1021 23.4533Z",
    fill: "",
    stroke: "black",
    strokeWidth: 0.24
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M27.991 19.5644L24.3422 19.5644L24.3422 23.2133L27.991 23.2133L27.991 19.5644Z",
    fill: "",
    stroke: "black",
    strokeWidth: 0.24
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M8.7866 27.3423L12.4354 27.3423L12.4354 30.9911L8.7866 30.9911L8.7866 27.3423Z",
    fill: "",
    stroke: "black",
    strokeWidth: 0.24
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2132 27.3423L16.5643 27.3423L16.5643 30.9911L20.2132 30.9911L20.2132 27.3423Z",
    fill: "",
    stroke: "black",
    strokeWidth: 0.24
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6755 31.2312L16.3243 31.2312L16.3243 34.88L12.6755 34.88L12.6755 31.2312Z",
    fill: "",
    stroke: "black",
    strokeWidth: 0.24
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6755 27.3423L16.3243 27.3423L16.3243 30.9911L12.6755 30.9911L12.6755 27.3423Z",
    fill: "",
    stroke: "black",
    strokeWidth: 0.24
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6755 23.4533L16.3243 23.4533L16.3243 27.1022L12.6755 27.1022L12.6755 23.4533Z",
    fill: "",
    stroke: "black",
    strokeWidth: 0.24
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6755 19.5644L16.3243 19.5644L16.3243 23.2133L12.6755 23.2133L12.6755 19.5644Z",
    fill: "",
    stroke: "black",
    strokeWidth: 0.24
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6755 15.6755L16.3243 15.6755L16.3243 19.3243L12.6755 19.3243L12.6755 15.6755Z",
    fill: "",
    stroke: "black",
    strokeWidth: 0.24
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6755 11.7866L16.3243 11.7866L16.3243 15.4354L12.6755 15.4354L12.6755 11.7866Z",
    fill: "",
    stroke: "black",
    strokeWidth: 0.24
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6755 7.89769L16.3243 7.89769L16.3243 11.5465L12.6755 11.5465L12.6755 7.89769Z",
    fill: "",
    stroke: "black",
    strokeWidth: 0.24
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6755 4.00879L16.3243 4.00879L16.3243 7.65761L12.6755 7.65761L12.6755 4.00879Z",
    fill: "",
    stroke: "black",
    strokeWidth: 0.24
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgScrollBtn);
export default __webpack_public_path__ + "static/media/scroll-btn.9b80e502.svg";
export { ForwardRef as ReactComponent };